import { render } from "./InputGroupAddon.vue?vue&type=template&id=0770256c"
import script from "./InputGroupAddon.vue?vue&type=script&lang=js"
export * from "./InputGroupAddon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__